export default __webpack_public_path__ + "static/media/placeholder_store04-en-mobile.88719793.png";